import {Component} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import screenfull from 'screenfull'
import {noop} from 'lodash'

export default class FullscreenToggle extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    onFullscreenChange: PropTypes.func.isRequired,
    forceAllowFullscreen: PropTypes.bool
  }

  static defaultProps = {
    onFullscreenChange: noop
  }

  componentDidMount() {
    if (screenfull.isEnabled) {
      screenfull.on('change', this.handleFullScreenChange)
    }
  }

  componentWillUnmount() {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.handleFullScreenChange)
    }
  }

  handleFullScreenChange = () => {
    this.props.onFullscreenChange(screenfull.isFullscreen)
  }

  toggle = () => screenfull.toggle(findDOMNode(this))

  isEnabled = () => this.props.forceAllowFullscreen || screenfull.isEnabled

  render() {
    return this.props.children
  }
}
